import React from 'react';

import '../style.less';

function PaymentMethods({ icons }) {
  return (
    <div className="flex flex-wrap items-center justify-center gap-4 rounded bg-white p-4 shadow-lg">
      {icons.map(icon => {
        return <img className="h-[26px] w-[40px]" src={icon} alt="" />;
      })}
    </div>
  );
}

export default PaymentMethods;
